import styled from "@emotion/styled";

const TextWithImagesRight = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.breakpoints.down("lg")} {
    align-items: center;
    width: 100%;
    gap: 20px;
    display: contents;
  }

  ${({ theme }) => theme.breakpoints.up("lg")} {
    width: 47%;
    gap: 40px;
  }
`;

export default TextWithImagesRight;
